<template>
    <accordion-item :keep-closed="true" :content-pull="true">
        <h2 slot="header">
            Past Loss of Earnings
        </h2>

        <div class="m-div-table__holder">

            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Disability Working Allowance"
                     store-key="ploeDisabilityWorkingAllowance"
                     show-Header
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Employment and Support Allowance"
                     store-key="ploeEmploymentSupportAllowance"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Incapacity Benefit"
                     store-key="ploeIncapacityBenefit"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Income Support"
                     store-key="ploeIncomeSupport"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Industrial Injuries Disablement Benefit"
                     store-key="ploeIndustrialInjuriesDisablementBenefit"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Invalidity Pension"
                     store-key="ploeInvalidityPension"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Invalidity Allowance"
                     store-key="ploeInvalidityAllowance"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Jobseeker’s Allowance"
                     store-key="ploeJobseekersAllowance"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Reduced Earnings Allowance"
                     store-key="ploeReducedEarningsAllowance"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Severe Disablement Allowances"
                     store-key="ploeSevereDisablementAllowance"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Sickness Benefit"
                     store-key="ploeSicknessBenefit"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Statutory Sick Pay paid before 6 April 1994"
                     store-key="ploeStatutorySickPay"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Unemployability Supplement"
                     store-key="ploeUnemployabilitySupplement"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Unemployment Benefit"
                     store-key="ploeUnemploymentBenefit"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Loss of Earnings"
                     subtitle="Universal Credit"
                     store-key="ploeUniversalCredit"
                     is-last
            ></benefit>

        </div>
    </accordion-item>
</template>
<script>
    import AccordionItem from 'components/accordion/AccordionItem';
    import Benefit from "./Benefit";

    export default {
        components: {
            Benefit,
            AccordionItem,
        },
        props: {
            estateType: {
                type: String,
                required: true
            }
        },
    }
</script>


// WEBPACK FOOTER //
// PastLossOfEarnings.vue?5e7668a4